import React, {useEffect, useMemo, useRef, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {IAppState, IDetailsBranch} from "../../store/models";
import {
    IFlyerRuntime, IFlyerRuntimePageSpot,
    IFlyerRuntimePageSpotPromo,
    IFreeItemDto, IFreeItemsInPromo,
    ItemState,
    PromosState,
    SellingUnitDto
} from "../../dtos/flyer";
import {
    findCurrentTranslateLabel,
    getPromoCaption,
    getPromoRegularPriceAndDiscount
} from "../../com/globalsFunctions/globalFunctions";
import {isMobile} from "react-device-detect";
import {toggleDetailsAction} from "../../store/actionsCreator/detailsActionsCreator";
import {setAddToMyListOneItemData} from "../../store/actionsCreator/addToMyListOneItemActionsCreator";
import {Box, Button, Grid, Typography} from "@mui/material";
import {PageSpinner} from "../pageSpinner/pageSpinner";
import {
    changeLoadingStatusForSelectedFrame, removeSelectedSpot,
    togglePromotionPopup
} from "../../store/actionsCreator/selectedSpotActionsCreator";
import {ReactComponent as CollapseHebrewFramePopupIcon} from "../../assets/icons/collapse_hebrew_frame_popup_icon.svg";
import {ReactComponent as CollapseFramePopupIcon} from "../../assets/icons/collapse_frame_popup_icon.svg";
import {ReactComponent as ExpandFramePopupIcon} from "../../assets/icons/expand_frame_popup_icon 2668.svg";
import {ReactComponent as Close} from "../../assets/icons/close_icon.svg";
import {AsyncImage} from "../imageComponent/image";
import {ReactComponent as PromoTagIconRed} from "../../assets/icons/promo_tag_red_icon.svg";
import {ReactComponent as PromoTagIconGreen} from "../../assets/icons/promo_tag_green_icon.svg";
import {Item} from "./item";
import {makeStyles} from "@mui/styles";
import {toggleShelfPromoDetailsPopup} from "../../store/actionsCreator/shelfPromoActionCreator";
import {StoreProjectDto} from "../../dtos/siteDto";


const useStyles = makeStyles(() => ({
    addToListContainer: (props: any) => ({
        display: `flex`,
        flexFlow: `column`,
        // maxHeight: `${document.documentElement.clientHeight}px`,
        direction: props.direction,
        backgroundColor: '#d4dade',
        border: `1px solid #858585`,
    }),
    addToListHeaderMenu: (props: any) => ({
        backgroundColor: `#ffffff`,
        // backgroundColor: `${props.backgroundColor}33`,
        padding: "5px 10px",
        // borderBottom: `1px solid rgb(133, 133, 133)`,
        '& .MuiTypography-root': {
            fontFamily: props.fontFamily,
            fontSize: props.isMobileView ? '18px' : '16px',
            wordBreak: 'break-word',
            textAlign: `start`,
            '&.textAlignEnd': {
                textAlign: `end`,
            }
        }
    }),
    promotionInfoSection: (props: any) => ({
        marginBottom: props.isPricelessFlyer ? `0` : `10px`
    }),
    promotionImage: (props: any) => ({
        height: props.isPricelessFlyer ? `170px` : '140px',
        maxHeight: '140px',
        minHeight: '140px',
        minWidth: `100%`,
        maxWidth: `100%`,
        display: `flex`,
        justifyContent: `center`,
        alignItems: `center`
    }),
    promotionDetails: {
        flex: `1 1 auto`,
        display: `flex`,
        flexFlow: `column`,
        height: `100%`
    },
    promotionCaption: {
        marginBottom: `8px`,
        '& > .MuiTypography-root': {
            fontWeight: `600`,
            fontSize: `20px!important`
        }
    },
    promotionType: {
        // flex: `1 1 auto`,
        marginBottom: `8px`,
        '& > .MuiTypography-root': {
            fontSize: `18px!important`,
            color: `#5A5A5A`
        }
    },
    promotionDate: (props: any) => ({
        '& > .MuiTypography-root': {
            fontSize: props.isMobileView ? `14px!important` : `16px!important`,
            color: `#5A5A5A`
        }
    }),
    promotionPricesSection: {
        display: `flex`,
        flexFlow: `column`,
        '& .MuiTypography-root': {
            lineHeight: '24px'
        }
    },
    promotionRegPrice: {
        marginBottom: `4px`,
    },
    promotionSaving: {
        marginBottom: `4px`,
        '& .MuiTypography-root': {
            color: '#C32E43'
        }
    },
    promotionTotalPrice: {
        '& .MuiTypography-root': {
            fontWeight: `700`
        }
    },
    addToListHeader: (props: any) => ({
        cursor: props.isExpandedPopup ? `move` : `default`,
        backgroundColor: '#d4dade',
        // backgroundColor: props.backgroundColor ? `${props.backgroundColor}80` : '#C32E4333',
        padding: `0 10px`,
        height: `40px`,
        minHeight: `40px`
    }),
    boxHeader: (props: any) => ({
        minHeight: `34px`,
        display: `flex`,
        alignItems: `center`,
        height: `100%`,
        fontSize: '20px',
        textAlign: `start`,
        wordBreak: 'break-word',
        '& > .MuiTypography-root': {
            fontFamily: props.fontFamily,
        },
        '&.validDateAddToListWrapper': {
            justifyContent: 'center'
        },
        '&.imageWrapper': {
            height: props.isPricelessFlyer && `170px`,
            maxHeight: '110px',
            minHeight: '110px',
            minWidth: `100%`,
            maxWidth: `100%`,
            display: `flex`,
            justifyContent: `center`
        }
    }),
    actionForFramePopupIconWrapper: (props: any) => ({
        justifyContent: 'flex-end',
        alignItems: `baseline`,
        '& .MuiButton-root': {
            width: `26px`,
            height: `26px`,
            '&:hover': {
                backgroundColor: props.backgroundColor ? `${props.backgroundColor}BF` : '#C32E43BF',
                '& svg:not(.expandedIcon) path': {
                    fill: '#ffffff',
                    stroke: '#ffffff'
                },
                '& svg path': {
                    stroke: '#ffffff'
                }
            },
            '&:active': {
                backgroundColor: props.backgroundColor ? `${props.backgroundColor}33` : '#C32E4333',
                '& svg:not(.expandedIcon) path': {
                    fill: '#ffffff',
                    stroke: '#ffffff'
                },
                '& svg path': {
                    stroke: '#ffffff'
                }
            }
        },
    }),
    addToListContent: (props: any) => ({
        flex: `1 1 auto`,
        overflow: `auto`,
        margin: props.promoItemsLength !== 1 ? `2px` : `0`
    }),
    addToListContentList: (props: any) => ({
        // height: props.promoItemsLength !== 1 ? `auto` : `100%`
    }),
    rootButtons: (props: any) => ({
        "&.MuiButton-root": {
            backgroundColor: `${props.backgroundColor}`,
            height: `30px`,
            borderRadius: `3px`,
            border: `0`,
            width: `100%`,
            fontWeight: `bold`,
            fontSize: props.isMobileView ? '16px' : '14px',
            fontFamily: props.fontFamily,
        },
        "&.MuiButton-contained": {
            color: "white"
        },
        '&:hover': {
            backgroundColor: props.backgroundColor ? `${props.backgroundColor}B3!important` : '#C32E43B3!important',
        },
        '&.Mui-disabled': {
            color: "white!important",
            backgroundColor: props.backgroundColor ? `${props.backgroundColor}4D!important` : '#C32E43B3!important',
        }
    }),
    addToListHeaderInfo: {
        padding: '0 0 10px'
    },
    typographyCustom: (props: any) => ({
        '&.MuiTypography-root': {
            textAlign: 'start',
            fontFamily: props.fontFamily,
            fontSize: props.isMobileView ? '16px' : '14px',
            wordBreak: 'break-word'
        },
        '&.priceSection': {
            textAlign: 'end',
            fontSize: props.isMobileView ? '18px' : '16px',
        },
        '&.promoAddToListCaption': {
            fontSize: `18px`,
            margin: '5px 0'
        },
        '&.validDateWrapperAddToList': {
            fontSize: props.isMobileView ? '14px' : '12px',
            textAlign: `center`
        }
    }),
    imageContainer: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    },
    orderCostInfoRow: {
        minHeight: '24px',
        '&.addToListDiscountSection': {
            color: '#C32E43'
        },
    },
    orderCostInfoRowNew: {
        minHeight: '24px',
    },
    addBtnWrapperAddToList: {
        display: 'flex',
        alignItems: 'center',
        height: `100%`
    },
    validDateWrapperAddToList: {
        fontSize: '12px'
    },
    benefitLine: {
        display: `flex`,
        flexDirection: `column`,
        justifyContent: `flex-start`,
        padding: `0 5px`,
    },
    benefitLineItem: {
        minHeight: `30px`,
        display: `flex`,
        alignItems: `center`,
        justifyContent: `center`,
        "& > .MuiTypography-root": {
            fontSize: "16px"
        }
    }
}));


interface Props {
    spot?: IFlyerRuntimePageSpot | null;
    pageImage?: string | null;
    isLoading?: boolean;
    isExpanded?: boolean;
    selectedPromo?: IFlyerRuntimePageSpotPromo | null;
}


export const AddToMyListPromoContentPopup: React.FC<Props> = ({
                                                                  spot,
                                                                  pageImage,
                                                                  isLoading,
                                                                  isExpanded,
                                                                  selectedPromo,
                                                              }) => {
    const dispatch = useDispatch();
    const flyerBranch = useSelector<IAppState, IFlyerRuntime | null>((state) => state.flyersBranch.data);
    const storeGlobalData = useSelector<IAppState, StoreProjectDto | null>((state) => state.storeData);
    const storeData = useSelector((state: IAppState) => state.shelvesScreen.data);
    const settingForPopup = storeGlobalData?.isFromFlyer ? flyerBranch : storeData?.storeSetting;
    const detailsBranch = useSelector<IAppState, IDetailsBranch | null>(state => state.detailsBranch);
    const {addToMyListOneItemData, myListState} = useSelector((state: IAppState) => state);
    // const {currentSlide} = useSelector((state: IAppState) => state.carouselBranch);
    const {controlsBranch} = useSelector((state: IAppState) => state);
    const {
        showBasket,
        isPortraitView
    } = controlsBranch;

    const isPricelessFlyer = settingForPopup?.typeCode === 3;
    const isShowPromoCaption = isPricelessFlyer &&
        (selectedPromo?.promoSaleTypeCode === 20 ||
            selectedPromo?.promoSaleTypeCode === 21 ||
            selectedPromo?.promoSaleTypeCode === 50 ||
            selectedPromo?.promoSaleTypeCode === 1 ||
            selectedPromo?.promoSaleTypeCode === 30 ||
            selectedPromo?.promoSaleTypeCode === 41 ||
            selectedPromo?.promoSaleTypeCode === 80 ||
            selectedPromo?.promoSaleTypeCode === 51);
    const [items, setItems] = useState<ItemState[]>([]);
    const [freeQtyItems, setFreeItemsQty] = useState<IFreeItemDto[]>([]);
    const [discount, setDiscount] = useState<number>(0);
    const [totalSalePrice, setTotalPrice] = useState<number>(0);
    const [totalRegularPrice, setTotalRegularPrice] = useState<number>(0);
    const [promoCaption, setPromoCaption] = useState<string>('');
    const [toDate, setTo] = useState<any>('');
    // const isMobile = useMediaQuery("(max-width:767px)", {noSsr: true});
    //translate caption
    const isHebrewStyle = settingForPopup?.dir === "RTL";
    const promoDisplayCaption = selectedPromo?.promoDisplayCaption1;
    // const addToBasketBtnCaption = findCurrentTranslateLabel(138, 'ADD TO LIST', data);
    // const totalCaption = findCurrentTranslateLabel(142, 'Total');
    const totalCaption = findCurrentTranslateLabel(169, 'Regular Price', settingForPopup);
    const validToCaption = findCurrentTranslateLabel(196, 'Valid unlit date', settingForPopup);
    const freeItemsCaption = findCurrentTranslateLabel(603, 'Free Items', settingForPopup);
    const discountCaption = findCurrentTranslateLabel(193, 'Save', settingForPopup);
    const salePriceCaption = findCurrentTranslateLabel(194, 'Sale Price', settingForPopup);
    const itemsCaption = findCurrentTranslateLabel(144, 'items', settingForPopup);
    const forBenefitLabel = findCurrentTranslateLabel(701, isHebrewStyle ? `בחרת {numberX} פריטים, בחר עוד {numberY} כדי להנות מהטבה` : `You selected {numberX} items, select {numberY} more to get benefit`, settingForPopup);
    const startBenefitLabel = findCurrentTranslateLabel(703, isHebrewStyle ? `בחר {numberY} פריטים כדי להנות מההטבה` : `Select {numberY} items to get the benefit`, settingForPopup);
    const withBenefitLabel = findCurrentTranslateLabel(702, isHebrewStyle ? 'קיבלת הטבה' : 'You got the benefit', settingForPopup);
    // const ExpiredOn = findCurrentTranslateLabel(529, 'Expired on', settingForPopup);
    const canvasRef = useRef(null);
    const totalSelectedItemsCount = useMemo((): number => {
        return parseFloat(
            items
                .reduce((acc, item) => {
                    return acc + item.count;
                }, 0)
                .toFixed(2)
        )
    }, [items]);

    const isMobileView = isPortraitView || isMobile;


    // const [totalFreeItemsCount, setTotalFreeItemsCount] = useState<number>(0);

    const getTotalBenefitItemsCount = (): number => {
        if (selectedPromo && selectedPromo?.promoSaleTypeCode! === 80) {
            const regularItemsWithoutBenefitItems = items.filter((item: ItemState) => {
                if (!item.spotItem.isBenefit) {
                    return item;
                }
            });
            const totalRegularItemsNumber: number = parseFloat(regularItemsWithoutBenefitItems.reduce((acc, item) => {
                let count = item.count;
                return acc + count;
            }, 0).toFixed(2));
            return Math.floor(totalRegularItemsNumber / (selectedPromo?.promoBuyQty ? selectedPromo?.promoBuyQty : 0));
        } else {
            if (freeQtyItems.length !== 0) {
                return freeQtyItems.reduce((acc, {itemCount}) => {
                    return acc + itemCount!;
                }, 0)
            } else {
                return 0
            }
        }
    }

    const styleProps = {
        backgroundColor: settingForPopup?.primaryColorRgb ? settingForPopup?.primaryColorRgb : `#C32E43`,
        direction: settingForPopup?.dir,
        fontFamily: settingForPopup?.font?.toLowerCase() || "roboto",
        isMobileView: isMobileView,
        isPricelessFlyer: isPricelessFlyer,
        promoItemsLength: selectedPromo?.items.length,
        benefitCount: getTotalBenefitItemsCount(),
        isExpandedPopup: isExpanded
    };
    const classes = useStyles(styleProps);
    const promotionSellingUnit = settingForPopup?.sellingUnits?.find((sellingUnit: SellingUnitDto) => {
        if (selectedPromo?.promoSellingUnitId === sellingUnit.id) {
            return sellingUnit;
        }
    })

    let promoImageSrc = selectedPromo?.promoImage && selectedPromo?.promoImage !== '' ? selectedPromo?.promoImage : spot ? "frameScreenshot" : '';

    // useEffect(() => {
    //     const sumOfFreeItems = freeQtyItems.reduce((acc, {itemCount}) => {
    //         return acc + itemCount!;
    //     }, 0);
    //     setTotalFreeItemsCount(sumOfFreeItems);
    // }, [freeQtyItems])

    useEffect(() => {
        toTimeStamp(settingForPopup?.validTo);
        setPromoCaption(getPromoCaption(selectedPromo!, isHebrewStyle, settingForPopup?.currencySymbol || "$", settingForPopup?.saleTypes || [], promotionSellingUnit));
        const toToCompair = toTimeStamp(selectedPromo?.promoValidToUtc.substring(0, 10));
        // console.log(fromToCompair,'fromToCompair');
        const mediumTo = new Date(toToCompair)
        const to = mediumTo.getDate() +
            "/" + (mediumTo.getMonth() + 1 < 10 ? `0${mediumTo.getMonth() + 1}` : mediumTo.getMonth() + 1) +
            "/" + mediumTo.getFullYear()
        setTo(to);
    }, [selectedPromo?.promoId]);

    useEffect(() => {
        const myListItemsForCurrentPromo: ItemState[] = getCurrentItemsForSelectedFrameInMyList(myListState.promos);
        const myListBenefitItemsForCurrentPromo: IFreeItemDto[] = getCurrentBenefitItemsForSelectedFrameInMyList(myListState.benefitItems);
        setItems(myListItemsForCurrentPromo);
        setFreeItemsQty(myListBenefitItemsForCurrentPromo);
    }, [myListState.promos, myListState.benefitItems, selectedPromo?.promoId])

    useEffect(() => {
        if (Boolean(detailsBranch)) {
            dispatch(toggleDetailsAction());
        }
        if (Boolean(addToMyListOneItemData.data)) {
            dispatch(setAddToMyListOneItemData(null));
        }
    }, [selectedPromo?.promoId])

    useEffect(() => {
        if (!isLoading) {
            const canvasContainer = canvasRef.current as HTMLCanvasElement | null;
            if (canvasContainer && pageImage && spot) {
                const image = new Image();
                const ctx = canvasContainer.getContext("2d");
                canvasContainer.style.width = 'inherit';
                canvasContainer.style.height = 'inherit';
                canvasContainer.width = canvasContainer.offsetWidth;
                canvasContainer.height = canvasContainer.offsetHeight;
                image.src = pageImage;
                image.addEventListener('load', () => {
                    if (ctx) {
                        let imgWidth = spot.spotX1PX - spot.spotX0PX;
                        let screenWidth = canvasContainer.width;
                        let scaleX = screenWidth / imgWidth;
                        let imgHeight = spot.spotY1PX - spot.spotY0PX;
                        let screenHeight = canvasContainer.height;
                        let scaleY = screenHeight / imgHeight;
                        let scale = scaleY;
                        if (scaleX < scaleY) {
                            scale = scaleX;
                        }
                        imgHeight = imgHeight * scale;
                        imgWidth = imgWidth * scale;
                        canvasContainer.style.width = `${imgWidth}px`;
                        canvasContainer.style.height = `${imgHeight}px`;
                        canvasContainer.height = imgHeight;
                        canvasContainer.width = imgWidth;

                        ctx.drawImage(
                            image,
                            spot.spotX0PX, //x0
                            spot.spotY0PX, // y0 Start at 70/20 pixels from the left and the top of the image (crop),
                            spot.spotX1PX - spot.spotX0PX, //x1 - x0
                            spot.spotY1PX - spot.spotY0PX, //y1 - y0 "Get" a `50 * 50` (w * h) area from the source image (crop),
                            0,
                            0, // Place the result at 0, 0 in the canvas,
                            // 100 * props.frame.fpsWidthPx! / props.frame.fpsHeightPx!,
                            // 100 * props.frame.fpsHeightPx! / props.frame.fpsWidthPx!
                            imgWidth,
                            imgHeight
                        ); // With as width / height: 100 * 100 (scale)

                    }
                })

            }
        }
    }, [isLoading, spot])
    const toTimeStamp = (aftercut: any) => {
        return Date.parse(aftercut);
    }

    /*
        useEffect(() => {
            const fromToCompair = toTimeStamp(data?.validFrom.substring(0, 10));
            console.log(fromToCompair, 'fromToCompair');
            const mediumFrom = new Date(fromToCompair)
            const fromDate = mediumFrom.getDate() +
                "/" + (mediumFrom.getMonth() + 1) +
                "/" + mediumFrom.getFullYear()
            // console.log(from,'from');
            setFrom(fromDate);
            setFromToCompair(fromToCompair);
            const toToCompair = toTimeStamp(data?.validTo.substring(0, 10));
            // console.log(fromToCompair,'fromToCompair');
            const mediumTo = new Date(toToCompair)
            const to = mediumTo.getDate() +
                "/" + (mediumTo.getMonth() + 1 < 10 ? `0${mediumTo.getMonth() + 1}` : mediumTo.getMonth() + 1) +
                "/" + mediumTo.getFullYear()
            setTo(to);
            setToToCompair(toToCompair);

        }, [data?.validFrom])
    */


    useEffect(() => {
        // changeItemsInBasket();
        const newPromo: PromosState = {
            ...selectedPromo!,
            items: items
        }
        let sumOfDiscount: number = getPromoRegularPriceAndDiscount(newPromo, items, freeQtyItems);
        setDiscount(sumOfDiscount);
        const totalPrice = getTotalPrice();
        setTotalPrice(totalPrice - sumOfDiscount);
        setTotalRegularPrice(totalPrice);
    }, [items, freeQtyItems]);


    const getTotalItems = (): number => {
        const totalItemsNumber: number = parseFloat(items.reduce((acc, item) => {
            let count = item.count;
            if (selectedPromo?.promoSellingUnitId && selectedPromo?.promoSellingUnitId !== 1 && selectedPromo?.promoSellingUnitId !== 8 && selectedPromo?.promoSellingUnitId !== 23) {
                count = 1;
            }
            return acc + count;
        }, 0).toFixed(2));
        if (selectedPromo?.promoSaleTypeCode! === 50 || selectedPromo?.promoSaleTypeCode! === 51) {
            return totalItemsNumber + getTotalBenefitItemsCount();
        } else {
            return totalItemsNumber
        }
    };

    const getTotalPrice = (): number => parseFloat(items.reduce((acc, {
        count,
        spotItem: {regularPrice: price, id: id, isBenefit}
    }) => {
        let itemWhichHasFreeItems = freeQtyItems.find((freeItem: IFreeItemDto) => freeItem.itemID === id);
        if (selectedPromo?.promoSellingUnitId && selectedPromo?.promoSellingUnitId !== 1 && selectedPromo?.promoSellingUnitId !== 8 && selectedPromo?.promoSellingUnitId !== 23) {
            return acc + ((price / selectedPromo?.promoBuyQty!) * count);
        }
        if ((selectedPromo?.promoSaleTypeCode! === 50 || selectedPromo?.promoSaleTypeCode! === 51) && itemWhichHasFreeItems) {
            return acc + ((price * count) + (itemWhichHasFreeItems?.itemCount! * price));
        } else if (selectedPromo?.promoSaleTypeCode! === 11) {
            return acc + (selectedPromo?.promoSalePrice! * count);
        } else {
            // if (isBenefit) {
            //     return acc;
            // } else {
            return acc + (price * count);
            // }
        }
    }, 0).toFixed(2));

    const getCurrentItemsForSelectedFrameInMyList = (promos: PromosState[]): ItemState[] => {
        if (!promos.length) {
            return [];
        }
        const currentPromoInFrame = promos.find(promoInBasket => promoInBasket.promoId === selectedPromo?.promoId);
        return currentPromoInFrame?.items || [];
    }

    const getCurrentBenefitItemsForSelectedFrameInMyList = (benefitItemsPromo: IFreeItemsInPromo[]): IFreeItemDto[] => {
        const currentPromoInFrame = benefitItemsPromo.find(promoInBasket => promoInBasket.promoId === selectedPromo?.promoId);
        return currentPromoInFrame?.freeItems || [];
    }
    /*
        let promoImageSrc = "";
        switch (selectedPromo?.promoImageSelection) {
            case 1:
                promoImageSrc = '';
                break;
            case 2:
                promoImageSrc = 'frameScreenshot';
                break;
            default:
                promoImageSrc = selectedPromo?.promoImage && selectedPromo?.promoImage !== '' ? selectedPromo?.promoImage : "frameScreenshot";
                break;
        }
    */

    let heightForContainer: string = `calc(${document.documentElement.clientHeight}px - 60px)`;
    let maxHeightForContainer: string = `calc(${document.documentElement.clientHeight}px - 60px)`;
    if (isMobileView) {
        heightForContainer = `100%`;
        maxHeightForContainer = `100%`;
    } else {
        if (isExpanded) {
            if (selectedPromo?.items.length === 1) {
                if (!isPricelessFlyer) {
                    heightForContainer = `64vh`;
                    maxHeightForContainer = `64vh`;
                } else {
                    heightForContainer = `80vh`;
                    maxHeightForContainer = `80vh`;
                }
            } else {
                heightForContainer = `auto`;
                maxHeightForContainer = `84vh`;
            }
        }
    }

    const itemsForPromo = useMemo(() => {
        if (!selectedPromo) {
            return [];
        }

        return selectedPromo.items.map((item) => {
            const currentPromo = myListState.promos.find((iterationPromo) => iterationPromo.promoId === selectedPromo.promoId);
            let currentItemCount = 0;
            if (currentPromo) {
                currentItemCount = currentPromo.items.find((iterationItem) => iterationItem.spotItem.id === item.id)?.count || 0;
            }
            return (
                <Item
                    currentItemCount={currentItemCount}
                    item={item}
                    promoType={selectedPromo.promoSaleTypeCode!}
                    promoQty={selectedPromo.promoBuyQty!}
                    promoSalePrice={selectedPromo.promoSalePrice!}
                    promoGetAmountOff={selectedPromo.promoGetAmountOff!}
                    key={item.id}
                    promotionSellingUnit={promotionSellingUnit}
                    promoItems={selectedPromo.items || []}
                    promoDisplayCaption={promoDisplayCaption ? promoDisplayCaption : ''}
                    isPricelessFlyer={isPricelessFlyer}
                    isShowPromoCaption={isShowPromoCaption}
                    promo={selectedPromo}
                />
            );
        });
    }, [selectedPromo, myListState.promos, promotionSellingUnit, promoDisplayCaption, isPricelessFlyer, isShowPromoCaption]);

    return (

        <Box className={classes.addToListContainer}
             sx={{
                 height: heightForContainer,
                 maxHeight: maxHeightForContainer,
                 // height: isMobile ? `100%` : isExpanded ? selectedPromo?.items.length === 1 ? (!isPricelessFlyer ? `64vh` : `80vh`) : `auto` : `calc(${document.documentElement.clientHeight}px - 60px)`,
                 // maxHeight: isMobile ? `100%` : isExpanded ? selectedPromo?.items.length === 1 ? (!isPricelessFlyer ? `64vh` : `80vh`) : `84vh` : `calc(${document.documentElement.clientHeight}px - 60px)`,
                 // maxHeight: selectedPromo?.items.length === 1 ? (!isPricelessFlyer ? `40vh` : `76vh`) : `76vh`,
             }}
        >
            {
                isLoading &&
                <Box sx={{
                    height: `100%`,
                    display: `flex`,
                    alignItems: `center`,
                    justifyContent: `center`,
                    minHeight: `64vh`,
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: "100%",
                    zIndex: 2,
                    backgroundColor: "white",
                    // position: "absolute"
                }}>
                    {/*<CircularProgress color={"info"}/>*/}
                    <PageSpinner/>
                </Box>
            }
            <>
                {
                    !isMobileView &&
                    <Grid
                        id="draggable-dialog-title"
                        container className={classes.addToListHeader}
                        justifyContent={`flex-end`}>
                        {/*{*/}
                        {/*    spot &&*/}
                        <Box sx={{display: `flex`, alignItems: `center`, margin: `0 5px`}}>
                            <Box className={`${classes.actionForFramePopupIconWrapper}`}>
                                <Button
                                    title={isExpanded ? `Collapse popup to side panel` : `Expand side panel to popup`}
                                    onClick={
                                        () => {
                                            dispatch(changeLoadingStatusForSelectedFrame(true));
                                            dispatch(togglePromotionPopup(isExpanded ? 'collapsed' : `expanded`));
                                            setTimeout(() => {
                                                dispatch(changeLoadingStatusForSelectedFrame(false));
                                            }, 500)
                                        }
                                    }>
                                    {
                                        isExpanded ?
                                            (isHebrewStyle ? <CollapseHebrewFramePopupIcon/> :
                                                <CollapseFramePopupIcon/>) :
                                            <ExpandFramePopupIcon className={`expandedIcon`}/>
                                    }
                                </Button>
                            </Box>
                        </Box>
                        {/*}*/}
                        <Box sx={{display: `flex`, alignItems: `center`}}>
                            <Box className={`${classes.actionForFramePopupIconWrapper}`}>
                                <Button onClick={
                                    () => {
                                        if (spot) {
                                            dispatch(removeSelectedSpot());
                                        } else {
                                            dispatch(toggleShelfPromoDetailsPopup(false));
                                        }
                                        if (!showBasket && Boolean(detailsBranch)) {
                                            dispatch(toggleDetailsAction());
                                        }
                                        if (!showBasket && Boolean(addToMyListOneItemData.data)) {
                                            dispatch(setAddToMyListOneItemData(null));
                                        }
                                    }
                                }>
                                    <Close/>
                                </Button>
                            </Box>
                        </Box>
                    </Grid>
                }
                {
                    selectedPromo?.items.length !== 1 &&
                    <Box className={classes.addToListHeaderMenu}>
                        <Grid container alignItems={`flex-end`}>
                            <Grid item xs={isExpanded && !isMobileView && !isPricelessFlyer ? 8 : 12}>
                                <Grid container columnSpacing={`10px`}
                                      className={!isExpanded || isMobileView ? classes.promotionInfoSection : ``}>
                                    <Grid item xs={isPricelessFlyer ? 3 : 4} className={classes.imageContainer}>
                                        <Box className={classes.promotionImage}>
                                            {promoImageSrc === "frameScreenshot" ?
                                                <canvas ref={canvasRef} style={{
                                                    maxWidth: 'inherit',
                                                    maxHeight: 'inherit'
                                                }}></canvas> :
                                                <AsyncImage
                                                    src={promoImageSrc}/>
                                            }
                                        </Box>
                                    </Grid>
                                    <Grid item xs>
                                        <Box className={classes.promotionDetails} title={promoDisplayCaption}>
                                            <Box className={classes.promotionCaption}>
                                                <Typography>{promoDisplayCaption}</Typography>
                                            </Box>
                                            {
                                                (!isPricelessFlyer || isShowPromoCaption) &&
                                                <Box className={classes.promotionType}>
                                                    <Typography>{promoCaption}</Typography>
                                                </Box>
                                            }
                                            <Box className={classes.promotionDate}>
                                                <Typography>{validToCaption} {toDate}</Typography>
                                            </Box>
                                        </Box>
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid item xs>
                                {
                                    !isPricelessFlyer &&
                                    <Box className={classes.promotionPricesSection}>
                                        {
                                            selectedPromo?.promoSaleTypeCode === 11 &&
                                            <Grid container
                                                  className={`${classes.promotionTotalPrice} ${classes.orderCostInfoRowNew}`}>
                                                {
                                                    getTotalItems() !== 0 &&
                                                    <>
                                                        <Grid item xs={8}>
                                                            <Typography>{salePriceCaption} ({getTotalItems()} {itemsCaption})</Typography>
                                                        </Grid>
                                                        <Grid item xs>
                                                            <Typography
                                                                className={`textAlignEnd`}>{settingForPopup ? settingForPopup.currencySymbol : "NIS"}{Number(totalSalePrice).toFixed(2)}</Typography>
                                                        </Grid>
                                                    </>
                                                }
                                            </Grid>
                                        }
                                        {
                                            selectedPromo?.promoSaleTypeCode !== 11 &&
                                            <>
                                                <Grid container
                                                      className={`${classes.promotionRegPrice} ${classes.orderCostInfoRowNew}`}>
                                                    <Grid item xs={8}>
                                                        <Typography>{totalCaption} ({getTotalItems()} {itemsCaption})</Typography>
                                                    </Grid>
                                                    <Grid item xs>
                                                        <Typography
                                                            className={`textAlignEnd`}>{settingForPopup ? settingForPopup.currencySymbol : "NIS"}{Number(totalRegularPrice).toFixed(2)}</Typography>
                                                    </Grid>
                                                </Grid>
                                                <Grid container
                                                      className={`${classes.promotionSaving} ${classes.orderCostInfoRowNew}`}>
                                                    {
                                                        discount !== 0 &&
                                                        <>
                                                            <Grid item xs={8}>
                                                                <Typography>{getTotalBenefitItemsCount() !== 0 ? `${discountCaption} (${getTotalBenefitItemsCount()} ${freeItemsCaption})` : discountCaption}</Typography>
                                                            </Grid>
                                                            <Grid item xs>
                                                                <Typography
                                                                    className={`textAlignEnd`}>{settingForPopup ? settingForPopup.currencySymbol : "NIS"}{discount.toFixed(2)}</Typography>
                                                            </Grid>
                                                        </>
                                                    }
                                                </Grid>

                                                <Grid container
                                                      className={`${classes.promotionTotalPrice} ${classes.orderCostInfoRowNew}`}>
                                                    <Grid item xs={8}>
                                                        <Typography>{salePriceCaption}</Typography>
                                                    </Grid>
                                                    <Grid item xs>
                                                        <Typography
                                                            className={`textAlignEnd`}>{settingForPopup ? settingForPopup.currencySymbol : "NIS"}{Number(totalSalePrice).toFixed(2)}</Typography>
                                                    </Grid>
                                                </Grid>
                                            </>
                                        }
                                    </Box>
                                }
                            </Grid>
                        </Grid>
                    </Box>

                }
                {
                    (selectedPromo?.promoSaleTypeCode! === 50 || selectedPromo?.promoSaleTypeCode! === 51 || selectedPromo?.promoSaleTypeCode! === 80) &&
                    <Box className={classes.benefitLine} sx={{
                        backgroundColor: getTotalBenefitItemsCount() === 0 ? `#F5DDE1` : `#D9EAD6`,
                    }}>
                        {
                            getTotalBenefitItemsCount && getTotalBenefitItemsCount() === 0
                                ?
                                <Box className={classes.benefitLineItem} sx={{
                                    justifyContent: `center`
                                }}>
                                    <Box sx={{width: `20px`, height: `20px`, display: `flex`, margin: `0 5px`}}>
                                        <PromoTagIconRed style={{width: `100%`, height: `100%`}}/>
                                    </Box>
                                    <Typography color={`#B42222`}>
                                        {
                                            totalSelectedItemsCount === 0 ?
                                                startBenefitLabel.replace(
                                                    /{numberY}/g,
                                                    selectedPromo!.promoBuyQty!.toString()) :
                                                forBenefitLabel
                                                    .replace(/{numberX}/g, totalSelectedItemsCount.toString())
                                                    .replace(
                                                        /{numberY}/g,
                                                        (selectedPromo?.promoBuyQty! - totalSelectedItemsCount).toString()
                                                    )
                                        }
                                    </Typography>
                                </Box>
                                :
                                items.map((item: ItemState) => {
                                    if (item.spotItem.isBenefit && item.count > 0) {
                                        return (
                                            <Box key={item.spotItem.id} className={classes.benefitLineItem}>
                                                <Box sx={{
                                                    width: `20px`,
                                                    height: `20px`,
                                                    display: `flex`,
                                                    margin: `0 5px`
                                                }}>
                                                    <PromoTagIconGreen style={{width: `100%`, height: `100%`}}/>
                                                </Box>
                                                <Typography color={`#4B9D3E`}>
                                                    {withBenefitLabel} {item.count} {item.spotItem.displayCaption1}!
                                                </Typography>
                                            </Box>
                                        )
                                    }
                                })
                        }
                        {
                            freeQtyItems.length !== 0 &&
                            freeQtyItems.map((freeItem: IFreeItemDto) => {
                                if (freeItem.itemCount && freeItem.itemCount > 0) {
                                    return (
                                        <Box key={freeItem.itemID} className={classes.benefitLineItem}>
                                            <Box sx={{
                                                width: `20px`,
                                                height: `20px`,
                                                display: `flex`,
                                                margin: `0 5px`
                                            }}>
                                                <PromoTagIconGreen style={{width: `100%`, height: `100%`}}/>
                                            </Box>
                                            <Typography color={`#4B9D3E`}>
                                                {withBenefitLabel} {freeItem.itemCount} {freeItem.benefitItemCaption}!
                                            </Typography>
                                        </Box>
                                    )
                                }
                            })
                        }
                    </Box>
                }
                {
                    (
                        selectedPromo?.promoSaleTypeCode! === 20
                        || selectedPromo?.promoSaleTypeCode! === 21
                        || selectedPromo?.promoSaleTypeCode! === 40
                        || selectedPromo?.promoSaleTypeCode! === 41
                        || selectedPromo?.promoSaleTypeCode! === 44
                    ) &&
                    <Box className={classes.benefitLine} sx={{
                        backgroundColor: discount === 0 ? `#F5DDE1` : `#D9EAD6`,
                    }}>
                        {
                            discount === 0 &&
                            <Box className={classes.benefitLineItem} sx={{
                                justifyContent: `center`
                            }}>
                                <Box sx={{width: `20px`, height: `20px`, display: `flex`, margin: `0 5px`}}>
                                    <PromoTagIconRed style={{width: `100%`, height: `100%`}}/>
                                </Box>
                                <Typography color={`#B42222`}>
                                    {
                                        totalSelectedItemsCount === 0 ?
                                            startBenefitLabel.replace(
                                                /{numberY}/g,
                                                ((selectedPromo?.promoSaleTypeCode! === 40 || selectedPromo?.promoSaleTypeCode! === 41 || selectedPromo?.promoSaleTypeCode! === 44)
                                                    ? selectedPromo?.promoBuyQty! + 1
                                                    : selectedPromo?.promoBuyQty!).toString()) :
                                            forBenefitLabel
                                                .replace(/{numberX}/g, totalSelectedItemsCount.toString())
                                                .replace(
                                                    /{numberY}/g,
                                                    ((selectedPromo?.promoSaleTypeCode! === 40 || selectedPromo?.promoSaleTypeCode! === 41 || selectedPromo?.promoSaleTypeCode! === 44)
                                                        ? selectedPromo?.promoBuyQty! + 1 - totalSelectedItemsCount
                                                        : selectedPromo?.promoBuyQty! - totalSelectedItemsCount).toString())
                                    }
                                </Typography>
                            </Box>
                        }
                        {
                            discount !== 0 &&
                            <Box className={classes.benefitLineItem}>
                                <Box sx={{
                                    width: `20px`,
                                    height: `20px`,
                                    display: `flex`,
                                    margin: `0 5px`
                                }}>
                                    <PromoTagIconGreen style={{width: `100%`, height: `100%`}}/>
                                </Box>
                                <Typography color={`#4B9D3E`}>
                                    {withBenefitLabel}!
                                </Typography>
                            </Box>
                        }
                    </Box>
                }
                <Box className={`${classes.addToListContent} customScrollBar`} sx={{
                    margin: selectedPromo?.items.length !== 1 ? `5px 2px` : `0`
                }}
                    // sx={{ flexGrow: 1, backgroundColor: `#ffffff`, margin: `0`, borderTop: `1px solid rgb(133, 133, 133)` }}
                >
                    <Grid container className={classes.addToListContentList} sx={{
                        height: selectedPromo?.items.length !== 1 ? `auto` : `100%`
                    }}>
                        {itemsForPromo}
                    </Grid>
                </Box>
            </>
        </Box>
    )

}